var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainerRef",staticClass:"scroll-container",style:({
		height: _vm.fixedHeight
			? _vm.fixedHeight
			: _vm.takeAvailableHeight
			? (_vm.height + "px")
			: 'auto'
	})},[(_vm.overlay)?_c('div',{staticClass:"scroll-container__overlay",style:({
			height: _vm.fixedHeight
				? _vm.fixedHeight
				: _vm.takeAvailableHeight
				? (_vm.height + "px")
				: 'auto'
		})}):_vm._e(),_vm._t("default"),(_vm.isInfinityScroll && _vm.hasMoreItems)?_c('Spinner',{attrs:{"processor":{ loading: true },"variant":"infinity-scroll"}}):_vm._e(),(_vm.isInfinityScroll && !_vm.hasMoreItems && _vm.showEndResultByDefault)?_c('div',{staticClass:"end-results"},[_vm._v(" End of results ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }